import './index.scss'
import { useEffect, useMemo, useRef, useState } from 'react';
import statisticsSignImg from '@/assets/image/home/statistics_sign.png'
import DisplayText from '../../../../components/DisplayText';
import { useMediaQuery } from 'react-responsive';
import { GetStatics } from '../../../../api/home';
import { formatKMB } from '@/utils'

const STATISTICS_REVEAL_STAGGER = 160
const STATISTICS_COUNT_DURATION = 1400

const getDesktopStatistics = (capitalValue) => [
  { value: capitalValue, prefix: '$', suffix: 'M', desc: 'Capital Under Enforcement' },
]

const getMobileStatistics = (capitalValue) => [
  {
    value: capitalValue,
    prefix: '$',
    suffix: 'M',
    desc: 'Capital Under Enforcement',
  },
]

const formatStatisticValue = (value, statistic) => {
  console.log(value)
  const formattedValue = statistic.decimals
    ? value.toFixed(statistic.decimals)
    : Math.round(value).toString()
  console.log("formattedValue===>",formattedValue)
  return `${statistic.prefix || ''}${formattedValue}${statistic.suffix || ''}`
}

const Statistics = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const statisticsRef = useRef(null)
  const [hasEntered, setHasEntered] = useState(false)
  const [animatedValues, setAnimatedValues] = useState([0, 0, 0])
  const [optimized,setOptimized] = useState(0)
  const fullText = 'Capital is already moving through Vishwa';
  const activeStatistics = useMemo(
    () => isMobile ? getMobileStatistics(optimized) : getDesktopStatistics(optimized),
    [isMobile, optimized]
  )

  const handleRequestData = () => {
    GetStatics().then((res) => {
      const assetNum = 100000000
      const num = Number(res+assetNum)
      setOptimized(num)
    })
  };

  useEffect(() => {
    handleRequestData()
  },[])

  useEffect(() => {
    const current = statisticsRef.current

    if (!current) return undefined

    if (!('IntersectionObserver' in window)) {
      setHasEntered(true)
      return undefined
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setHasEntered(true)
          observer.disconnect()
        }
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    )

    observer.observe(current)

    return () => observer.disconnect()
  },[])

  useEffect(() => {
    const targetValues = activeStatistics.map((statistic) => statistic.value)

    if (!hasEntered) {
      setAnimatedValues(targetValues.map(() => 0))
      return undefined
    }

    const shouldReduceMotion = typeof window !== 'undefined'
      && window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches

    if (shouldReduceMotion) {
      setAnimatedValues(targetValues)
      return undefined
    }

    let animationFrameId
    const startTime = performance.now()

    const animateValues = (timestamp) => {
      const nextValues = targetValues.map((targetValue, index) => {
        const elapsed = timestamp - startTime - index * STATISTICS_REVEAL_STAGGER
        const progress = Math.min(Math.max(elapsed / STATISTICS_COUNT_DURATION, 0), 1)
        const easedProgress = 1 - Math.pow(1 - progress, 3)

        return targetValue * easedProgress
      })

      setAnimatedValues(nextValues)

      if (nextValues.some((value, index) => value < targetValues[index])) {
        animationFrameId = requestAnimationFrame(animateValues)
      } else {
        setAnimatedValues(targetValues)
      }
    }

    setAnimatedValues(targetValues.map(() => 0))
    animationFrameId = requestAnimationFrame(animateValues)

    return () => cancelAnimationFrame(animationFrameId)
  }, [activeStatistics, hasEntered])

  return (
    <div ref={statisticsRef} className={`statistics w-1340 ${hasEntered ? 'statistics--entered' : ''} ${isMobile ? '' : 'pb-[80px]'}`}>
      {
        isMobile ? (
          <div className="statistics-mobile">
            <div className="statistics-mobile-header statistics-content-reveal" style={{ '--statistics-reveal-delay': '0ms' }}>
              <span className="statistics-mobile-eyebrow">Vishwa Traction</span>
              <h2>{fullText}</h2>
              <p>$170M+ capital enforced before execution across trading, payments, and treasury systems.</p>
            </div>

            <div className="statistics-content-wrap statistics-mobile-grid">
              <article
                className="statistics-content-item statistics-content-reveal statistics-mobile-card"
                style={{ '--statistics-reveal-delay': `160ms` }}
              >
                <div className="statistics-mobile-card-top">
                  <img className="statistics-content-item-img" src={statisticsSignImg} alt="" />
                </div>
                <div className="statistics-content-item-value">
                  {formatKMB(animatedValues[0])}
                </div>
                <p className="statistics-content-item-desc">{activeStatistics[0].desc}</p>
              </article>
            </div>
          </div>
        ) : (
          <div className={`flex items-center`}>
            <div className={`statistics-left mr-[100px]`}>
              <div className={`h-[234px]  w-[680px]`}>
                <DisplayText fullText={fullText} />
              </div>
              <div className="statistics-left-subtitle w-[720px]">
                $170M+ capital enforced before execution across trading, payments, and treasury systems.
              </div>
            </div>
            <div className={`statistics-content-wrap gap-[128px]`}>
            <div className={`statistics-content-item statistics-content-reveal w-[230px] mb-[86px]`}
                   style={{ '--statistics-reveal-delay': '0ms' }}>
                <div className={`statistics-content-item-img`}>
                  <img className={`w-[46px] h-[20px] mb-[12px]`} src={statisticsSignImg} alt="" />
                </div>
                <div className={`statistics-content-item-value text-[50px] mt-[12px]`}>{formatKMB(animatedValues[0])}</div>
                <div className={`statistics-content-item-desc text-[18px] text-[#A9A9A9]`}>{activeStatistics[0].desc}</div>
              </div>
            </div>
          </div>
        )
      }

    </div>
  )
}

export default Statistics
